/**
 * jQuery shim for esbuild
 * Makes jQuery available as $ and jQuery from window global
 */
export const $ = window.$;
export const jQuery = window.jQuery;
export default $;
